import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@ad3d/ui";

export function EditorLayout({ children }: { children?: React.ReactNode }) {
    return (
        <div className="h-screen w-full overflow-hidden bg-transparent text-foreground">
            <ResizablePanelGroup direction="horizontal">
                <ResizablePanel defaultSize={10} minSize={10} maxSize={15} className="hidden md:block bg-sidebar/5 backdrop-blur-[2px] pointer-events-auto">
                    <div className="h-full w-full">
                        {/* Left Sidebar Content */}
                    </div>
                </ResizablePanel>
                
                <ResizableHandle className="hidden md:block w-0 bg-transparent pointer-events-auto" />
                
                <ResizablePanel defaultSize={60}>
                    <div className="h-full w-full relative">
                        {children}
                    </div>
                </ResizablePanel>
                
                <ResizableHandle className="hidden md:block w-0 bg-transparent pointer-events-auto" />
                
                <ResizablePanel defaultSize={10} minSize={10} maxSize={15} className="hidden md:block bg-sidebar/5 backdrop-blur-[2px] pointer-events-auto">
                    <div className="h-full w-full">
                        {/* Right Sidebar Content */}
                    </div>
                </ResizablePanel>
            </ResizablePanelGroup>
        </div>
    );
}
